export default "__VITE_ASSET__DtFyik7I__"